import styled from 'styled-components'

export const Container = styled.div`
  min-height: 100vh;
  // background: var(--Bg_, #f2f0ef);
`

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 52px;
  padding: 0px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 100;
`

export const LeftActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .back-btn {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 8px 16px;
    border: none;
    background: none;
    cursor: pointer;
    color: #666;

    &:hover {
      color: #333;
    }
  }
`

export const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  .action-btn {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 8px 16px;
    border-radius: 20px;
    background: #fff;
    cursor: pointer;
    color: var(--Grays-Gray-1, #23262f);
    font-family: Rubik;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: capitalize;

    &:hover {
      background: #f5f5f5;
    }

    &.primary {
      background: #1a73e8;
      color: white;
      border-color: #1a73e8;

      &:hover {
        background: #1557b0;
      }
    }
  }
`

export const Content = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding: 32px 24px;
  display: flex;
  justify-content: center;
`

export const SkeletonWrapper = styled.div`
  width: 100%;
  .skeleton-header {
    height: 48px;
    margin-bottom: 24px;
    background: #f0f0f0;
    border-radius: 4px;
  }

  .skeleton-paragraph {
    > div {
      height: 16px;
      background: #f0f0f0;
      border-radius: 4px;
      margin-bottom: 16px;

      &:nth-child(2n) {
        width: 95%;
      }

      &:nth-child(3n) {
        width: 80%;
      }
    }
  }
`
